"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2018-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var core_1 = require("@jsonforms/core");
var react_1 = require("@jsonforms/react");
var core_2 = require("@material-ui/core");
var merge_1 = __importDefault(require("lodash/merge"));
var react_2 = __importDefault(require("react"));
var MaterialInputControl_1 = require("./MaterialInputControl");
var findEnumSchema = function (schemas) {
    return schemas.find(function (s) { return s.enum !== undefined && (s.type === 'string' || s.type === undefined); });
};
var findTextSchema = function (schemas) {
    return schemas.find(function (s) { return s.type === 'string' && s.enum === undefined; });
};
var MuiAutocompleteInputText = function (props) {
    var data = props.data, config = props.config, className = props.className, id = props.id, enabled = props.enabled, uischema = props.uischema, isValid = props.isValid, path = props.path, handleChange = props.handleChange, schema = props.schema;
    var enumSchema = findEnumSchema(schema.anyOf);
    var stringSchema = findTextSchema(schema.anyOf);
    var maxLength = stringSchema.maxLength;
    var appliedUiSchemaOptions = merge_1.default({}, config, uischema.options);
    var inputProps = {};
    if (appliedUiSchemaOptions.restrict) {
        inputProps = { maxLength: maxLength };
    }
    if (appliedUiSchemaOptions.trim && maxLength !== undefined) {
        inputProps.size = maxLength;
    }
    var onChange = function (ev) { return handleChange(path, ev.target.value); };
    inputProps.list = props.id + 'datalist';
    var dataList = (react_2.default.createElement("datalist", { id: props.id + 'datalist' }, enumSchema.enum.map(function (optionValue) { return (react_2.default.createElement("option", { value: optionValue, key: optionValue })); })));
    return (react_2.default.createElement(core_2.Input, { type: 'text', value: data || '', onChange: onChange, className: className, id: id, disabled: !enabled, autoFocus: appliedUiSchemaOptions.focus, fullWidth: !appliedUiSchemaOptions.trim || maxLength === undefined, inputProps: inputProps, error: !isValid, endAdornment: dataList }));
};
var MaterialAnyOfStringOrEnumControl = /** @class */ (function (_super) {
    __extends(MaterialAnyOfStringOrEnumControl, _super);
    function MaterialAnyOfStringOrEnumControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialAnyOfStringOrEnumControl.prototype.render = function () {
        return (react_2.default.createElement(MaterialInputControl_1.MaterialInputControl, __assign({}, this.props, { input: MuiAutocompleteInputText })));
    };
    return MaterialAnyOfStringOrEnumControl;
}(react_1.Control));
exports.MaterialAnyOfStringOrEnumControl = MaterialAnyOfStringOrEnumControl;
var hasEnumAndText = function (schemas) {
    // idea: map to type,enum and check that all types are string and at least one item is of type enum,
    var enumSchema = findEnumSchema(schemas);
    var stringSchema = findTextSchema(schemas);
    var remainingSchemas = schemas.filter(function (s) { return s !== enumSchema || s !== stringSchema; });
    var wrongType = remainingSchemas.find(function (s) { return s.type && s.type !== 'string'; });
    return enumSchema && stringSchema && !wrongType;
};
var simpleAnyOf = core_1.and(core_1.uiTypeIs('Control'), core_1.schemaMatches(function (schema) { return schema.hasOwnProperty('anyOf') && hasEnumAndText(schema.anyOf); }));
exports.materialAnyOfStringOrEnumControlTester = core_1.rankWith(5, simpleAnyOf);
exports.default = react_1.withJsonFormsControlProps(MaterialAnyOfStringOrEnumControl);
//# sourceMappingURL=MaterialAnyOfStringOrEnumControl.js.map